export enum DragTypeStationEnum {
  NOT_DRAGGING = "NOT_DRAGGING",
  STATION = "STATION",
}
